import { render } from "./HowItWorks.vue?vue&type=template&id=3e014a70&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=3e014a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e014a70"]])

export default __exports__